export const DAY_WINDOWS = [7, 3, 1];
